import { createSlice } from '@reduxjs/toolkit';
import {
	getWorkOrderList,
	getWorkOrder,
	addNewWorkOrder,
	updateWorkOrder,
	deleteWorkOrder,
} from './thunk';

export const initialState = {
	data: [],
	dataToEdit: null,
	error: null,
	isListLoading: false,
	isListLoaded: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	requireRefetch: false,
};

const WorkOrderSlice = createSlice({
	name: 'WorkOrder',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireRefetch(state, action) {
			state.requireRefetch = action.payload;
		},
		setDataToEdit(state, action) {
			state.dataToEdit = action.payload;
		},
		resetWorkOrderFlags(state) {
			state.isAdded = false;
			state.isAddError = false;
			state.isUpdated = false;
			state.isUpdateError = false;
			state.isDeleted = false;
			state.isDeleteError = false;
			state.requireCloseModal = false;
		},
	},
	extraReducers: builder => {
		// getWorkOrderList
		builder.addCase(getWorkOrderList.pending, state => {
			state.isListLoading = true;
			state.isListLoaded = false;
		});
		builder.addCase(getWorkOrderList.fulfilled, (state, action) => {
			state.data = action.payload;
			state.isListLoading = false;
			state.isListLoaded = true;
		});
		builder.addCase(getWorkOrderList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isListLoading = false;
		});

		// getWorkOrder
		builder.addCase(getWorkOrder.pending, state => {
			state.isListLoading = true;
		});
		builder.addCase(getWorkOrder.fulfilled, (state, action) => {
			state.dataToEdit = action.payload;
			state.isListLoading = false;
		});
		builder.addCase(getWorkOrder.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isListLoading = false;
		});

		// addNewWorkOrder
		builder.addCase(addNewWorkOrder.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWorkOrder.fulfilled, state => {
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
			state.requireRefetch = true;
		});
		builder.addCase(addNewWorkOrder.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		// updateWorkOrder
		builder.addCase(updateWorkOrder.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWorkOrder.fulfilled, state => {
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
			state.requireRefetch = true;
		});
		builder.addCase(updateWorkOrder.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		// deleteWorkOrder
		builder.addCase(deleteWorkOrder.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteWorkOrder.fulfilled, state => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
			state.requireRefetch = true;
		});
		builder.addCase(deleteWorkOrder.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireRefetch,
	setDataToEdit,
	resetWorkOrderFlags,
} = WorkOrderSlice.actions;

export default WorkOrderSlice.reducer;
